module.exports = __webpack_public_path__ + "img/1-2.e4205cb7.webp";